import { TranslationsType } from "react-native-paper-dates";

const vi: TranslationsType = {
  save: "Lưu",
  selectSingle: "Chọn ngày",
  selectMultiple: "Chọn nhiều ngày",
  selectRange: "Chọn khoảng ngày",
  notAccordingToDateFormat: (inputFormat: string) => `Giá trị ngày là kiểu ${inputFormat}`,
  mustBeHigherThan: "Phải lớn hơn",
  mustBeLowerThan: "Phải nhỏ hơn",
  mustBeBetween: "Phải trong khoảng",
  dateIsDisabled: "Ngày không được chọn",
  previous: "Trước",
  next: "Sau",
  typeInDate: "Kiểu ngày",
  pickDateFromCalendar: "Chọn ngày từ lịch",
  close: "Đóng",
};
export default vi;
